module.exports = __webpack_public_path__ + "static/media/human-body.0fd8bd22.png";